import { render, staticRenderFns } from "./progression.vue?vue&type=template&id=72727e9f&"
import script from "./progression.vue?vue&type=script&lang=js&"
export * from "./progression.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports